import { render, staticRenderFns } from "./PaymentGroupForm.vue?vue&type=template&id=6063ea6c"
import script from "./PaymentGroupForm.vue?vue&type=script&lang=js"
export * from "./PaymentGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports